/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

export const HEADER_BUTTON_STATE_CLASSES = [
  "text-white transition-colors",
  "hover:bg-forest-green-700 hover:text-morning-dew-50",
  "active:bg-forest-green-950 active:text-morning-dew-50",
  "focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-white",
  "disabled:cursor-not-allowed disabled:bg-transparent disabled:text-neutral-400",
];
